const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("veloclin_token")}` });

export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const isoToBr = (iso) => (iso && iso.includes("-") ? iso.split("-").reverse().join("/") : iso || "");

export const getOverview = async (id) => {
  const r = await fetch(`${API}/api/clinic/patients/${id}/overview`, { headers: auth() });
  if (!r.ok) throw new Error("Falha ao carregar o paciente");
  return r.json();
};

export const uploadFile = async (id, file, category) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await fetch(`${API}/api/clinic/patients/${id}/files?category=${encodeURIComponent(category)}`, { method: "POST", headers: auth(), body: fd });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Falha no envio do arquivo");
  return d.file;
};

const openBlob = async (url, filename, download) => {
  const r = await fetch(url, { headers: auth() });
  if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.detail || "Falha ao abrir o arquivo"); }
  const blobUrl = URL.createObjectURL(await r.blob());
  const a = document.createElement("a");
  a.href = blobUrl;
  if (download) a.download = filename; else a.target = "_blank";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

export const openFile = (f) => openBlob(`${API}/api/clinic/files/${f.id}`, f.name, false);
export const deleteFile = async (f) => {
  const r = await fetch(`${API}/api/clinic/files/${f.id}`, { method: "DELETE", headers: auth() });
  if (!r.ok) throw new Error("Falha ao remover o arquivo");
};
export const downloadReceipt = (apptId) => openBlob(`${API}/api/clinic/appointments/${apptId}/receipt`, `recibo-${apptId.slice(-8)}.pdf`, true);
export const markNoShow = async (apptId) => {
  const r = await fetch(`${API}/api/clinic/appointments/${apptId}/no-show`, { method: "PATCH", headers: auth() });
  if (!r.ok) throw new Error("Falha ao marcar falta");
};

export const waLink = (phone, name) => {
  let d = (phone || "").replace(/\D/g, "");
  if (!d) return "";
  if (!d.startsWith("55")) d = `55${d}`;
  return `https://wa.me/${d}?text=${encodeURIComponent(`Olá ${(name || "").split(" ")[0]}, tudo bem? Aqui é da clínica.`)}`;
};
